import { apiRequest } from "./client";

// Snapshot returned by GET /v1/admin/metrics. Counters are point-in-time
// (no streaming). DAU/WAU/MAU = distinct parents with `lastSeenAt`
// inside the 24h / 7d / 30d window. Retention buckets exclude parents
// who signed up inside the last 30 days (they haven't had a fair chance
// to come back yet).
export type MetricsSnapshot = {
  generatedAt: string;
  parents: {
    total: number;
    newLast7d: number;
    newLast30d: number;
    dau: number;
    wau: number;
    mau: number;
    cohortEligible: number;
    retentionWeekPct: number;
    retentionMonthPct: number;
  };
  kids: { total: number };
  sessions: { total: number; totalMinutes: number };
  // Stripe status → count. Keys include any of: inactive, trialing,
  // active, past_due, canceled, incomplete, incomplete_expired, unpaid.
  subscriptions: Record<string, number>;
};

export const metricsApi = {
  // Both 403 and 401 are possible: 403 when the parent isn't in
  // ADMIN_EMAILS, 401 when the JWT is missing/expired. The dashboard
  // surfaces either as "you don't have access".
  snapshot: (token: string) =>
    apiRequest<MetricsSnapshot>("/v1/admin/metrics", { token }),
};
